export default {
  openButton: "Crear con IA",
  title: "Creación rápida con IA",
  close: "Cerrar",
  descriptors: "Descriptores",
  noDescriptors:
    "La institución no tiene descriptores definidos para {entity}.",
  // Fallbacks de los nombres alternativos institucionales.
  egressProfileLabel: "el Perfil de Egreso",
  competences: "Competencias",
  competenceLabel: "competencia",
  alreadyExists: "Ya existente",
  remove: "Quitar",
  restore: "Volver a añadir",
  regenerate: "Regenerar",
  addCompetence: "Añadir {entity}",
  noType: "Sin tipo",
  noCycle: "Sin ciclo",
  themePlaceholder: "Ej: enfoque en sostenibilidad, innovación, vinculación con el medio...",
  themeHint:
    "Tema opcional para orientar la regeneración (máximo 200 caracteres).",
  themeInfo:
    "Opcional: escribe palabras clave o un énfasis para orientar la redacción del descriptor o la competencia; no necesitas escribir extenso. Ej.: “innovación tecnológica”, “investigación aplicada”, “vinculación con el medio”.",
  generating: "Generando contenido con IA...",
  generateError:
    "No fue posible generar el contenido. Intente nuevamente más tarde.",
  cancel: "Cancelar",
  confirmSave: "Confirmar y guardar",
  savedToast: "Objetos creados correctamente.",
  saveError:
    "Ocurrió un error al guardar los objetos generados. Intente nuevamente.",
};
